import { render } from "./editAbstract.vue?vue&type=template&id=2894a313&scoped=true"
import script from "./editAbstract.vue?vue&type=script&lang=js"
export * from "./editAbstract.vue?vue&type=script&lang=js"

import "./editAbstract.vue?vue&type=style&index=0&id=2894a313&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2894a313"],['__file',"src/views/aiProduct/components/editAbstract.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2894a313"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2894a313', __exports__)) {
    console.log('reload')
    api.reload('2894a313', __exports__)
  }
  
  module.hot.accept("./editAbstract.vue?vue&type=template&id=2894a313&scoped=true", () => {
    console.log('re-render')
    api.rerender('2894a313', render)
  })

}


export default __exports__